import React, { useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import SelectCity from "./SelectCity";
import EditLocation from "../../../components/EditLocation";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { ICity, ISearchCriteira } from "../utils/interfaces";
import UsernameSearch from "./UsernameSearch";
import TagsPoolSearch from "./TagsPoolSearch";
import { TagProps } from "../../../typings/tag";
import {
  resetSearchData,
  setSearchMembersResults,
  setTagsPoolSearch,
} from "../../../redux/searchUsers";
import { getTagsPool, getUsersBySearch } from "../../../services/searchService";
import {
  HOMEPAGE,
  SEARCH_MEMBERS_RESULTS,
} from "../../../navigation/Constants";
import { SearchMembers } from "../../../typings/member";
import Loader from "react-loader-spinner";
import usePrepareLink from "../../../hooks/usePrepareLink";
import { GET_PARAMS, GET_POPUPS } from "../../../const/router";
import { getMemberPremiumStatus } from "../../../services/memberService";
import { SubscriptionPlans } from "../../../helpers/Enums";

const SearchUserByCriteria = () => {
  const history = useHistory();
  // const member = useSelector((state: RootState) => state.member);

  const [allTagsInSearchPage, setAllTagsInSearchPage] = useState<TagProps[]>(
    []
  );

  const dispatch = useDispatch();
  const { isPremium, subscriptionPlanId } = useSelector(
    (state: RootState) => state.member
  );

  const searchUsers = useSelector((state: RootState) => state.searchUsers);

  const premiumMessagelink = usePrepareLink({
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.premiumMessage,
    },
    keepOldQuery: true,
  });

  useEffect(() => {
    const getAllTagsPool = async () => {
      //Clears all data (we need it when we go back in browser)
      dispatch(resetSearchData());

      const tags: any = await getTagsPool();
      // setTagsPool(tags.data);

      setAllTagsInSearchPage(tags.data);
      dispatch(setTagsPoolSearch(tags.data));
      console.log("3333333333");
    };
    getAllTagsPool();
  }, [dispatch]);

  // const onSelectedCity = (selectedCity: ICity) => {
  //   console.log("onSelectedCity selectedCity: ", selectedCity);
  //   setSearchCriteria({ ...searchCriteria, city: searchCriteria.city });
  // };

  // const onInputUserName = (inputText: string) => {
  //   console.log("onInputUserName inputText: ", inputText);
  //   setSearchCriteria({ ...searchCriteria, userName: searchCriteria.userName });
  // };

  // const onSelectedTags = (selectedTags: TagProps[]) => {
  //   console.log("onSelectedTags selectedTags:", selectedTags);
  // };

  const handleUsersSearch = async () => {
    console.log("handleSubmit searchUsers: ", searchUsers);

    const { city, username, tagsPool } = searchUsers;

    const selectedTagsIds = tagsPool
      .filter((tag) => tag.isSelected)
      .map((selectedTag) => selectedTag.value)
      .join(",");

    if (!isPremium || subscriptionPlanId === SubscriptionPlans.LIGHT) {
      history.push(premiumMessagelink);
      return;
    }

    const response = await getUsersBySearch(
      city?.id,
      username,
      selectedTagsIds
    );

    //TODO: This is only for DEV Purposes
    // const searchedResultsWithProfileImageUrl = response.data.map(
    //   (member: SearchMembers) => {
    //     member.profileImageUrl = `https://localhost:44360\\Resources\\${member.profileImageUrl}`;
    //     return member;
    //   }
    // );

    console.log("handleUsersSearch getUsersBySearch response:", response);
    dispatch(setSearchMembersResults(response.data));
    // dispatch(setSearchMembersResults(searchedResultsWithProfileImageUrl));

    history.push(SEARCH_MEMBERS_RESULTS);
  };

  const handleResetSearch = () => {
    dispatch(resetSearchData());
    dispatch(setTagsPoolSearch(allTagsInSearchPage));
  };

  return (
    <>
      <div className="content_sec full">
        <div className="search_top">
          {/* <button
            name="btn-go-back-search-user-screen"
            onClick={() => history.goBack()}
            className="top_back search w-inline-block"
          >
            <img src="assets/images/ic_back_white.svg" loading="lazy" alt="" />
          </button> */}

          <NavLink className="top_back search w-inline-block" to={HOMEPAGE}>
            <img src="assets/images/ic_back_white.svg" loading="lazy" alt="" />
          </NavLink>

          <div className="prem_toptitle_block">
            <img
              src="assets/images/prem_banner_pict.svg"
              loading="lazy"
              alt=""
              className="prem_toptitle_pict"
            />
            <h2 className="search_top_title">חיפוש אנשים</h2>
            <img
              src="assets/images/prem_banner_pict.svg"
              loading="lazy"
              alt=""
              className="prem_toptitle_pict mirror"
            />
          </div>
        </div>

        <div className="search_sec w-form">
          <form
            id="email-form"
            name="email-form"
            data-name="Email Form"
            method="get"
            data-wf-page-id="668b914f732ce0a1e451af31"
            data-wf-element-id="5e845afb-3a75-3324-7700-c67fb6e43da2"
            // onSubmit={handleSubmit}
            // onSubmit={(e: any) => {
            //   e.preventDefault();
            //   console.log("submit submit submit");
            // }}
          >
            <div className="form_field_content people_search">
              <div>
                <p>
                  <span>חיפוש מתקדם לחברי שושק'ה פרימיום</span>
                  <br />
                  <NavLink
                    to={{ pathname: "https://www.motke.co.il/shoshke_search" }}
                    target="_blank"
                  >
                    <span>עזרה</span>
                  </NavLink>
                  {/* <span>עזרה</span>
                  <br />
                  <span>https://www.motke.co.il/shoshke_search</span> */}
                </p>
              </div>
            </div>

            {/* <div
              style={{
                margin: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader type="ThreeDots" color="#f47373" height={60} width={60} />
            </div> */}

            <div className="form_field_content">
              <SelectCity />
              <UsernameSearch />
              <TagsPoolSearch />
            </div>

            <div className="form_send_group">
              <div className="form_buttons_group filtering">
                <button
                  type="button"
                  data-wait=""
                  className="button filtering w-button"
                  // value="חיפוש"
                  onClick={handleUsersSearch}
                >
                  חיפוש
                </button>
                <button
                  type="button"
                  className="clear_link"
                  onClick={handleResetSearch}
                  style={{ backgroundColor: "transparent" }}
                >
                  איפוס
                </button>
              </div>
            </div>
          </form>
          {/* <div className="w-form-done">
            <div>Thank you! Your submission has been received!</div>
          </div>
          <div className="w-form-fail">
            <div>Oops! Something went wrong while submitting the form.</div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default SearchUserByCriteria;
